<template>
  <div
    class="page-buttons-wrapper bb-row bb-justify-content-end"
    :class="{ '--one-page': pageInfo.num_pages === 1 }"
    v-if="!areResultsEmpty && !isLoading && pageInfo.count > 12"
  >
    <button
      class="prev-page bb-button bb-fcenter bb-mr-1"
      :disabled="computedCurrentPage === 1"
      @click="prevPage"
    >
      <span
        class="chevron-icon prev-icon"
        v-html="require('common/icons/Chevron.svg')"
      ></span>
    </button>

    <div class="page-buttons">
      <template v-if="pageInfo.num_pages < 8">
        <PageButton
          v-for="page in pageInfo.num_pages"
          :key="page"
          :page="page"
          :currentPage="computedCurrentPage"
          @click="changePage(page)"
        />
      </template>

      <template v-else>
        <PageButton
          v-if="computedCurrentPage > 2"
          :page="1"
          :currentPage="computedCurrentPage"
          @click="changePage(1)"
        />
        <span
          class="bb-description-3 bb-bold elipsis-paginated"
          v-if="computedCurrentPage > 3"
        >
          ...
        </span>
        <PageButton
          v-for="page in maxPages"
          :key="page"
          :page="page"
          :currentPage="computedCurrentPage"
          v-if="page >= minPages"
          @click="changePage(page)"
        />
        <span
          class="bb-description-3 bb-bold elipsis-paginated"
          v-if="computedCurrentPage < pageInfo.num_pages - 2"
        >
          ...
        </span>
        <PageButton
          v-if="computedCurrentPage < pageInfo.num_pages - 1"
          :page="pageInfo.num_pages"
          :currentPage="computedCurrentPage"
          @click="changePage(pageInfo.num_pages)"
        />
      </template>
    </div>

    <button
      class="next-page bb-button bb-fcenter"
      :disabled="computedCurrentPage === pageInfo.num_pages"
      @click="nextPage"
    >
      <span
        class="chevron-icon next-icon"
        v-html="require('common/icons/Chevron.svg')"
      ></span>
    </button>
  </div>
</template>

<script>
  import PageButton from './component/PageButton.vue';

  export default {
    components: {
      PageButton,
    },
    props: {
      pageInfo: Object,
      currentPage: Number,
      areResultsEmpty: Boolean,
      isLoading: Boolean,
      minPages: {
        type: Number,
        default: 1,
      },
      maxPages: {
        type: Number,
      },
    },
    data() {
      return {
        internalCurrentPage: this.currentPage,
      };
    },
    computed: {
      computedCurrentPage: {
        get() {
          return this.internalCurrentPage;
        },
        set(value) {
          this.internalCurrentPage = value;
          this.$emit('update:currentPage', value);
        },
      },
    },
    watch: {
      currentPage(newVal) {
        this.internalCurrentPage = newVal;
      },
    },
    methods: {
      prevPage() {
        if (this.computedCurrentPage > 1) {
          this.computedCurrentPage--;
        }
      },
      nextPage() {
        if (this.computedCurrentPage < this.pageInfo.num_pages) {
          this.computedCurrentPage++;
        }
      },
      changePage(page) {
        this.computedCurrentPage = page;
      },
    },
  };
</script>

<style lang="scss" scoped>
  @import '~assets/styles/index.scss';
  .page-buttons-wrapper {
    align-self: flex-end;
    height: auto;
    gap: 8px;
    &.--one-page {
      max-width: 80px;
    }

    @media (max-width: $screen-xs-max) {
      width: 100%;
      max-width: 500px;
      margin: 0 auto;
    }

    .bb-button {
      padding: 0;
      width: 38px;
      height: 38px;
      display: flex;
      justify-content: center;
      align-items: center;
      border-radius: 8px;
    }

    .page-buttons {
      height: 100%;
      background: #fbfbfb;
      border-radius: 8px;
      font-size: 0;
      flex: 0;
      display: flex;
      justify-content: center;

      @media (max-width: $screen-xs-max) {
        display: flex;
        width: 100%;
        flex: 1;
      }

      .bb-button,
      span {
        margin-right: 2px;
      }

      .bb-button {
        background-color: #fbfbfb;
        transition: 0.3s;
        flex: 0 1 38px;
        height: 38px;

        @media (max-width: $screen-xs-max) {
          width: 100%;
        }

        &:last-of-type {
          margin-right: 0;
        }

        &:hover {
          background-color: $PRIMARY;
          color: $WHITE;
        }

        &.--selected {
          background-color: $PRIMARY;
          color: $WHITE;
        }

        &.--number {
          width: 31px;
        }
      }
      .elipsis-paginated {
        display: flex;
        align-items: center;
        justify-content: center;
      }
    }

    .prev-page {
      background-color: $PRIMARY;
      color: $WHITE;
      .prev-icon {
        transform: rotate(90deg);
      }
      &:disabled {
        background-color: $GRAY-LIGHT;
        color: $WHITE;
        cursor: not-allowed;
        pointer-events: none;
      }
    }

    .next-page {
      background-color: $PRIMARY;
      color: $WHITE;
      .next-icon {
        transform: rotate(-90deg);
      }
      &:disabled {
        background-color: $GRAY-LIGHT;
        color: $WHITE;
        cursor: not-allowed;
        pointer-events: none;
      }
    }

    .chevron-icon {
      width: 12px;

      svg {
        margin-bottom: 2px;
        width: inherit;
        height: inherit;
      }

      g {
        stroke: $WHITE;
        stroke-width: 3px;
      }
    }
  }
</style>
